module.exports = __webpack_public_path__ + "static/7-b94f03f3f232d2b5580f040cc5b58e78.png";